import React from 'react';
import './events.css';
import TechEvent from './images/TechEvent.jpg';
import CulturalEvent from './images/CulturalEvent.jpg';
import LiteraryEvent from './images/LiteraryEvent.jpg';
import FineArtsEvent from './images/FineArtsEvent.jpg';
import { Link as RouterLink } from "react-router-dom";

const Events = () => {

    return (
        <section id="timeline">
            <div className="tl-item">
                <div className="tl-bg" style={{ backgroundImage: 'linear-gradient(rgba(0,0,0,0.25),rgba(0,0,0,0.25)), url(' + TechEvent + ')' }}></div>
                <div className="tl-year">
                    <p className="f2 heading--sanSerif">Technical</p>
                </div>
                <div className="tl-content">
                    <h1>Check your Technical Skills</h1>
                    <p>Technical events are a check for you to showcase your technical skills. This is the time for Geeks to go on a war with their code as a sword and show this world that you have some exceptional skills to change the worlds. Lets Go Coders !!</p>
                    <br />
                    <RouterLink to="/technical"><div className="tl-btn" >Check Events</div></RouterLink>
                </div>
            </div>
            <div className="tl-item">
                <div className="tl-bg" style={{ backgroundImage: 'linear-gradient(rgba(0,0,0,0.25),rgba(0,0,0,0.25)), url(' + CulturalEvent + ')' }}></div>
                <div className="tl-year">
                    <p className="f2 heading--sanSerif">Cultural</p>
                </div>
                <div className="tl-content">
                    <h1 className="f3 text--accent ttu">Are you Up with your Team?</h1>
                    <p>In the Annual Fest of ABESIT , Cultural events are the perfect blend of challenging an Individual or Group to test yourself and to enjoy with your friends.These events bring up the Enthusiasm level of youth and motivate them to do more. </p>
                    <br />
                    <RouterLink to="/cultural"><div className="tl-btn" >Check Events</div></RouterLink>
                </div>
            </div>
            <div className="tl-item">
                <div className="tl-bg" style={{ backgroundImage: 'linear-gradient(rgba(0,0,0,0.25),rgba(0,0,0,0.25)), url(' + LiteraryEvent + ')' }}></div>
                <div className="tl-year">
                    <p className="f2 heading--sanSerif">Literary</p>
                </div>
                <div className="tl-content">
                    <h1 className="f3 text--accent ttu">Show us your Creativity</h1>
                    <p>From the most exotic debate to Jam and spellBee, all these events are always a Buzz to watch and opportunity to show your love for literatute. Grab the opportunity and show your literary skills.</p>
                    <br />
                    <RouterLink to="/literary"><div className="tl-btn" >Check Events</div></RouterLink>
                </div>
            </div>
            <div className="tl-item">
                <div className="tl-bg" style={{ backgroundImage: 'linear-gradient(rgba(0,0,0,0.25),rgba(0,0,0,0.25)), url(' + FineArtsEvent + ')' }}></div>
                <div className="tl-year">
                    <p className="f2 heading--sanSerif">Fine Arts</p>
                </div>
                <div className="tl-content">
                    <h1 className="f3 text--accent ttu">Lets Talk about your Poetry</h1>
                    <p>Fine Arts is an 'extravaganza' that has diverse coverage of events catering to almost every cultural art form imaginable. Let the artist inside you do the magic and amaze the world with your art.</p>
                    <br />
                    <RouterLink to="/finearts"><div className="tl-btn" >Check Events</div></RouterLink>
                </div>
            </div>

        </section>
    )
}

export default Events